import React, { useState } from 'react';
import { referralRequest } from '../utils/referrals';

/** One-time username for the /r/ link. Used by the dashboard card and the navbar gift panel. */
export default function ReferralHandleForm({ onSaved, onNotice }) {
  const [handle, setHandle] = useState('');
  const [saving, setSaving] = useState(false);
  async function save(e) {
    e.preventDefault(); setSaving(true); onNotice('');
    try { const saved = await referralRequest('set_handle', { handle }); onSaved(saved.handle); onNotice('Username saved.'); }
    catch (err) { onNotice(err.message); }
    finally { setSaving(false); }
  }
  return <form className="referral-handle" onSubmit={save}>
    <label>Choose a username for your link (optional, set once)
      <input aria-label="Referral username" value={handle} maxLength={20} placeholder="e.g. alex-tan"
        onChange={e => setHandle(e.target.value.toLowerCase())} />
    </label>
    <button className="btn-ghost" type="submit" disabled={saving || handle.trim().length < 3}>Save username</button>
  </form>;
}
